import React, { useEffect } from 'react'
import PrivateRoute from '../../components/PrivateRoute'

import { useParams, useNavigate } from 'react-router-dom'

import {
  Card,
  CardContent,
  Typography,
  Alert,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Box
} from '@mui/material'

import AddIcon from '@mui/icons-material/Add';

import { useDispatch, useSelector } from 'react-redux'

import { getProfile } from '../../actions/userActions'
import { getPublicPlaylists, addSongToPlaylist } from '../../actions/playlistActions'

const AddSongToPlaylist = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { id } = useParams()
  const { userInfo } = useSelector(state => state.userState)
  const { playlists: publicPlaylists, error } = useSelector(state => state.playlistState)
  const { profile } = useSelector(state => state.userState)

  useEffect(() => {
    if (userInfo && (userInfo.role === 'admin' || userInfo.role === 'superadmin')) {
      dispatch(getPublicPlaylists())
    }
  }, [userInfo])

  useEffect(() => {
    dispatch(getProfile())
  }, [])

  return (
    <PrivateRoute>
      <Card sx={{ maxWidth: 800, mx: 'auto', mt: 5, p: 1 }}>
        <CardContent>
          {error && <Alert severity='error' sx={{ mb: 2 }}>{error}</Alert>}
          {publicPlaylists && <>
            <Typography variant='h6' gutterBottom sx={{ ml: 2 }}>Public Playlists</Typography>
            <List sx={{ mb: 3 }}>
              {publicPlaylists.map(playlist => (
                <Box key={playlist._id}>
                  <ListItem disablePadding>
                    <ListItemButton onClick={() => dispatch(addSongToPlaylist(playlist._id, id, navigate))}>
                      <ListItemText
                        primary={playlist.title}
                        secondary={playlist.songs.length + ` ${playlist.songs.length === 1 ? 'song' : 'songs'}`}
                      />
                      <ListItemIcon>
                        <AddIcon />
                      </ListItemIcon>
                    </ListItemButton>
                  </ListItem>
                </Box>
              ))}
            </List>
          </>}

          {profile && <>
            <Typography sx={{ ml: 2 }} gutterBottom variant='h6'>Your private playlists</Typography>
            <List>
              {profile.playlists.map(playlist => !playlist.isPublic &&
                <Box key={playlist._id}>
                  <ListItem disablePadding>
                    <ListItemButton onClick={() => dispatch(addSongToPlaylist(playlist._id, id, navigate))}>
                      <ListItemText
                        primary={playlist.title}
                        secondary={playlist.songs.length + ` ${playlist.songs.length === 1 ? 'song' : 'songs'}`}
                      />
                      <ListItemIcon>
                        <AddIcon />
                      </ListItemIcon>
                    </ListItemButton>
                  </ListItem>
                </Box>
              )}
            </List>
          </>}
        </CardContent>
      </Card>
    </PrivateRoute>
  )
}

export default AddSongToPlaylist